export default {
  valorModel: {
    type: Boolean,
    required: true,
  },

  parametros_dialog: {
    type: Object,
    required: true
  },

  dados: {
    type: [Object, Array],
    require: true
  },

  idsegmento: {
    type: [Array, String],
    default: []
  },

  idfornecedor: {
    type: [Array, String],
    default: []
  },

  idcomprador: {
    type: [Array, String],
    default: []
  },

  selecionadoGrid: Boolean,
}
